import { sessionifyCookie } from '@rategravity/frontend/modules/hubspot';
import React from 'react';
import { sessionifyAuthToken } from '../modules/authenticate';
import { CONSULT_CONSTANT } from '../modules/consult-paths';
import session from './dashboard/session';
import { Purchase } from './meta';

class SessionifyDashboard extends React.Component {
  componentWillMount() {
    sessionifyAuthToken();
    sessionifyCookie();
  }

  render() {
    return this.props.children;
  }
}

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.Dashboard = session(props.dashboard);
  }

  componentWillMount() {
    const stage = this.props.viewer.primaryBorrower.email ? 'dashboard' : 'questionnaire';
    this.setState({ stage });
  }

  onComplete() {
    this.setState({ stage: 'dashboard' });
    // All questionnaires load into the deck to start, but if the questionnaire is
    //   already finished, it will run the onComplete logic. In order to not re-submit
    //   the questionnaire, we check to see if we already know the consult pitch output
    //   and skip the loader if not.
    if (!sessionStorage.getItem(CONSULT_CONSTANT)) {
      this.props.router.replace(`/${this.props.path}/complete`);
    }
  }

  renderQuestionnaire({ questionnaire, dashboard, meta: Meta = Purchase, children, ...props }) {
    const Questionnaire = questionnaire;
    return (
      <Questionnaire {...props} onComplete={this.onComplete.bind(this)}>
        <Meta />
        {children}
      </Questionnaire>
    );
  }

  renderDashboard({ router, children, viewer, meta: Meta = Purchase, ...props }) {
    const Dashboard = this.Dashboard;

    return (
      <SessionifyDashboard>
        <Dashboard {...props} router={router} viewer={viewer}>
          <Meta />
          {children}
        </Dashboard>
      </SessionifyDashboard>
    );
  }

  render() {
    switch (this.state.stage) {
      case 'questionnaire':
        return this.renderQuestionnaire(this.props);
      case 'dashboard':
        return this.renderDashboard(this.props);
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/product.js